import { ax } from '@/main.js'

const state = {
  approvalStati: [],
  keywordTypes: [
    { 'name': 'Brand', 'icon': 'copyright'},
    { 'name': 'Competitor', 'icon': 'sports_kabaddi'},
    { 'name': 'Performance', 'icon': 'speed'},
  ],
}

const mutations = {
  setApprovalStati (state, list) {
    state.approvalStati = list
  },
}

// no error handling: let caller handle with try/catch outside store
const actions = {
  async loadApprovalStati ({ commit }) {
    const resp = await ax.get('/a/nkw/approval-stati')
    commit('setApprovalStati', resp.data.data)
  },

  async deleteBookingsByProvider ({ commit }, providerID) {
    return await ax.put('/a/nkw/delete-bookings-by-provider', { providerID })
  },

  async changeRegion ({ commit }, { bookingIDs, newRegionID }) {
    return await ax.put('/a/nkw/change-region', { bookingIDs, newRegionID })
  },

  async changeTerritory ({ commit }, { bookingIDs, newRegionID, newCountryID }) {
    return await ax.put('/a/nkw/change-territory', { bookingIDs, newRegionID, newCountryID })
  },

  async replaceTerritories ({ commit }, { bookingIDs, newRegionIDs, newCountryIDs }) {
    return await ax.put('/a/nkw/replace-territories', { bookingIDs, newRegionIDs, newCountryIDs })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}